import React, { useEffect, useState } from "react";
import "./TagInput.scss";

const TagInput = ({
  placeholder = "Add item...", // Placeholder text for the input
  onChange, // Callback when tags change
  onError, // Callback when there's a validation error
  validateTag, // Optional custom tag validation from parent
  value = [], // Initial tag list
}) => {
  const [tags, setTags] = useState([]); // Internal state for tags
  const [input, setInput] = useState(""); // State for input text

  // Function to add a new tag
  const addTag = (tag) => {
    const trimmed = tag.trim();

    // If empty string, show error
    if (!trimmed) {
      if (onError) onError("This field cannot be empty.");
      return;
    }

    // Prevent duplicate tags
    const existTag = tags.findIndex((tag) => tag.value === trimmed);
    if (existTag !== -1) {
      if (onError) onError("This tag has already been added.");
      return;
    }

    // Optional external validation
    if (validateTag) {
      const { valid, error } = validateTag(trimmed);
      if (!valid) {
        if (onError) onError(error);
        return;
      }
    }

    // Add the new tag with readOnly = false
    const updatedTags = [
      ...tags,
      {
        value: trimmed,
        readOnly: false,
      },
    ];
    setTags(updatedTags);
    setInput(""); // clear input
    if (onError) onError(""); // clear error
    if (onChange) onChange(updatedTags);
  };

  // Handles keyboard interaction with the input
  const handleKeyDown = (e) => {
    // Add tag on Enter or comma
    if ((e.key === "Enter" || e.key === ",") && input.trim()) {
      e.preventDefault();
      addTag(input);
    }
    // Backspace: remove last tag (if not readOnly)
    else if (e.key === "Backspace" && input === "") {
      const lastTag = tags[tags.length - 1];
      if (lastTag?.readOnly) return; // Don't remove readOnly tag
      const updatedTags = tags.slice(0, -1); // remove last tag
      setTags(updatedTags);
      onChange && onChange(updatedTags);
    }
  };

  // Remove a tag (unless it's readOnly)
  const removeTag = (indexToRemove) => {
    const tagToRemove = tags[indexToRemove];
    if (tagToRemove?.readOnly) return; // prevent removing readOnly tags

    const updatedTags = tags.filter((_, i) => i !== indexToRemove);
    setTags(updatedTags);
    onChange && onChange(updatedTags);
  };

  useEffect(() => {
    if (value.length) {
      setTags(value);
    }
  }, [value]);

  return (
    <>
      <div
        className="tag-input border rounded"
        onClick={() => document.getElementById("customTagInput").focus()} // Focus input when container is clicked
      >
        {/* Render each tag as a badge */}
        {tags.map((tag, idx) => {
          return (
            <span
              key={idx}
              className="badge tag text-white"
              style={{
                opacity: tag.readOnly ? 0.7 : 1, // Slightly faded if readOnly
                cursor: tag.readOnly ? "not-allowed" : "default",
              }}
            >
              {tag.value}
              {/* Show close icon only if tag is not readOnly */}
              {!tag.readOnly && (
                <span
                  onClick={() => removeTag(idx)}
                  className="material-icons close-icon"
                >
                  close
                </span>
              )}
            </span>
          );
        })}

        {/* Input field to add new tags */}
        <input
          id="customTagInput"
          type="text"
          className="border-0 flex-grow-1 input-type"
          value={input}
          placeholder={placeholder}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
    </>
  );
};

export default TagInput;
